import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);


export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module-simple-tabs';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$select_options =  [];

		this.index = -1;

		this.init();
    }

    init(){
    	//console.log( 'init Tabs' );
    	//-------------------- init menu ------------------------------------------//
    	this.$lis 		= this.$el.find( '.tab-header li' );
    	this.$lis.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    		if ( $(el).hasClass( 'active' ) ){
    			this.index = i;
    		}
    	});

    	//-------------------- init tabs ------------------------------------------//
    	this.$tabs 		= this.$el.find( '.tab-container .tab-content' );
    	this.$tabs.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    	});

    	this.addEvents( true );

    	/*
    	if ( !this.checkHash() ){
    		this.setIndex( this.index, true );
    	}
    	*/
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$lis.find( 'a' ).on( 'click', (e) => this.onSelectTab(e) );

			/*
			window.addEventListener( "hashchange", ()=>this.onHashChange() , false );

			if ( this.$select_options.length > 0 ){
				this.$el.find( '.tab-menu select' ).on( 'change', (e)=>this.onSelectMobileSelect(e) );
			}
			*/
		}
		else{
			this.$lis.find( 'a' ).off( 'click', (e) => this.onSelectTab(e) );

			/*
			window.removeEventListener( "hashchange", ()=>this.onHashChange() , false );

			if ( this.$select_options.length > 0 ){
				this.$el.find( '.tab-menu select' ).off( 'change', (e)=>this.onSelectMobileSelect(e) );
			}
			*/
		}
	}

	onSelectTab( e ){
		e.preventDefault();

		let $a = $(e.currentTarget), index = $a.parent().attr( 'data-index' );

		// deselect current index
		if ( this.index !== -1 ){
			this.setIndex( this.index, false );
		}

		// select next index
		this.setIndex( index, true );

 	}

 	/*
 	onSelectMobileSelect( e ){
 		let $el = $(e.currentTarget), index = $el.find( ':selected' ).attr( 'data-index' );
 		this.$lis.eq( index ).find( 'a' ).click();
 	}
	*/

 	setIndex( i, b ){
 		//console.log( 'setIndex' + i + ', b = '  + b );
 		if ( b ){
 			this.$lis.eq( i ).addClass( 'active' );
 			this.$tabs.eq( i ).addClass( 'active' );

 			this.index = i;
 		}
 		else{
 			this.$lis.eq( i ).removeClass( 'active' );
 			this.$tabs.eq( i ).removeClass( 'active' );
 		}
 	}

 	/*
 	checkHash(){
 		let hash = document.location.hash, menuItem;

 		if ( hash ){
 			hash = hash.substring(1).replace( /-/g , ' ');

	    	this.$lis.each( ( i, el )=>{

	    		menuItem = $(el).find( 'a' ).text().toLowerCase();
	    		if ( menuItem.indexOf( hash ) !== -1 ){

	    			this.setIndex( this.index, false );
	    			this.setIndex( i, true );

	    			setTimeout(()=>this.scrollToTabs(), 200 );

	    			return true;
	    		}

	    	});
 		}

 		return false;
 	}

 	onHashChange( ){
 		this.checkHash()
 	}
 	*/

 	scrollToTabs(){
 		gsap.to( $(window), {duration: 0.8, scrollTo: { y : this.$el[0], offsetY: 60 }, delay: 0.4, ease: 'power.easeOut' });
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}
